import { cn } from '@/utils/tailwind.util';
import { BottomLabel, type BottomLabelProps } from './BottomLabel';
import { TopLabel, type TopLabelProps } from './TopLabel';
export const WithLabel = (props: Partial<TopLabelProps> & Partial<BottomLabelProps> & {
  className?: string;
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
}) => {
  // 상단 accessory가 있는 조건.
  // optional('선택 사항')은 title 의 수식어라 단독으로는 상단 영역을 만들지 않는다
  // (title 없는 검색 TextField 에 빈 라벨 영역이 뜨던 문제 방지).
  const withTopAccessory = props.title || props.titleLeftSlot || props.titleRightSlot || props.description || props.rightSlot;
  return <div className={cn('flex w-full flex-col gap-3xs', props.className)} data-sentry-component="WithLabel" data-sentry-source-file="WithLabel.tsx">
      {!!withTopAccessory && <div className="flex justify-between">
          <TopLabel title={props.title} titleLeftSlot={props.titleLeftSlot} titleRightSlot={props.titleRightSlot} optional={props.optional} description={props.description} />
          {props.rightSlot}
        </div>}
      {props.children}
      {props.helperText && <BottomLabel helperText={props.helperText} error={props.error} />}
    </div>;
};